import ModalCadastro from "../../../../../components/ModalCadastro/ModalCadastro.tsx";
import ModalConfirmacao from "../../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../../components/ModalUsuario/ModalUsuario.tsx";

interface ModaisVeiculosProps {
    open: boolean;
    handleClose: () => void;
    deletarVeiculoPorId: () => void;
    openCadastro: boolean;
    handleCloseCadastro: () => void;
    openCadastroProprietario: boolean;
    handleCloseCadastroProprietario: () => void;
    openCadastroCaminhao: boolean;
    handleCloseCadastroCaminhao: () => void;
    openCadastroCarreta: boolean;
    handleCloseCadastroCarreta: () => void;
    openCadastroCarroceria: boolean;
    handleCloseCadastroCarroceria: () => void;
    openCadastroTipoVeiculo: boolean;
    handleCloseCadastroTipoVeiculo: () => void;
    openUsuario: boolean;
    handleCloseUsuario: () => void;
    disable?: boolean;
}

function ModaisVeiculos({
    open,
    handleClose,
    deletarVeiculoPorId,
    openCadastro,
    handleCloseCadastro,
    openCadastroProprietario,
    handleCloseCadastroProprietario,
    openCadastroCaminhao,
    handleCloseCadastroCaminhao,
    openCadastroCarreta,
    handleCloseCadastroCarreta,
    openCadastroCarroceria,
    handleCloseCadastroCarroceria,
    openCadastroTipoVeiculo,
    handleCloseCadastroTipoVeiculo,
    openUsuario,
    handleCloseUsuario,
    disable
}: ModaisVeiculosProps) {

    return (
        <>
            <ModalConfirmacao
                titulo="Deletar"
                texto="Deseja Deletar?"
                open={open}
                onClose={handleClose}
                onClick={deletarVeiculoPorId}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroMotorista="sim"
                open={openCadastro}
                desabilitar={disable}
                onClose={handleCloseCadastro}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroProprietario="sim"
                open={openCadastroProprietario}
                desabilitar={disable}
                onClose={handleCloseCadastroProprietario}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroCaminhao="sim"
                open={openCadastroCaminhao}
                desabilitar={disable}
                onClose={handleCloseCadastroCaminhao}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroCarreta="sim"
                open={openCadastroCarreta}
                desabilitar={disable}
                onClose={handleCloseCadastroCarreta}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroCarroceria="sim"
                open={openCadastroCarroceria}
                desabilitar={disable}
                onClose={handleCloseCadastroCarroceria}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroTipoVeiculo="sim"
                open={openCadastroTipoVeiculo}
                desabilitar={disable}
                onClose={handleCloseCadastroTipoVeiculo}
            />
            <ModalUsuario
                titulo="Usuário"
                tituloConfirmar="OK"
                open={openUsuario}
                onClose={handleCloseUsuario}
            />
        </>
    )
};

export default ModaisVeiculos;